// extracted by mini-css-extract-plugin
export default {"container":"RK-z","topReviewHeading":"SK-z","criticalReview":"TK-z","favorableReview":"UK-z","vsSeparator":"VK-z"};